import { Component, OnInit } from '@angular/core';

import AOS from 'aos';

@Component({
    selector: 'gs-about',
    templateUrl: './about.component.html',
    standalone: false
})
export class AboutComponent implements OnInit {

  ngOnInit() {
    setTimeout(() => {
      //Fix AOS not triggering when route animations are enabled
      AOS.refresh();
    }, 500);
  }

}
